import { ButtonType } from '../enum/button-type.enum';

export interface BannerConfig {
  title?: string;
  icon?: string;
  description?: string;
  style: BannerStyle;
  closeButtonClicked?: () => void;
  buttons?: BannerButtonConfig[];
}

export enum BannerStyle {
  Info,
  Error,
  Warning,
  Success,
}

export interface BannerButtonConfig {
  title: string;
  leadingIconName?: string;
  trailingIconName?: string;
  style: ButtonType;
  onClick: () => void;
}
